<template>
  <h2 :class="`font-weight-light ${defaultColor}--text mt-0`"> {{text}} </h2>
</template>
<script>

import UIMixin from "@/mixins/UIMixin";

export default {
  mixins: [UIMixin],
  props: {
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
    }
  },
  computed:{
    defaultColor(){
      const vm = this
      if(vm.color) return vm.color

      return vm.isDark ? 'white' : 'secondary'
    }
  }
}
</script>
<style scoped>
h2 {
  font-size: 16px;
}
</style>
